module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.01798bc1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/icons/pe7-icon/fonts/Pe-icon-7-stroke.ttf?d7yf1v
// module id = ./src/assets/components/icons/pe7-icon/fonts/Pe-icon-7-stroke.ttf?d7yf1v
// module chunks = 7